export const PromoCodeType = {
  GENERAL: 0,
  UNIQUE: 1
}